import { Box, Grid, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import "./InstCentersStyle.css";
import centersImg_en from "../../imgs/InstallationCenters_en.png";
import centersImg_ar from "../../imgs/InstallationCenters_ar.png";

import { Context } from "../LocalWrapper";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

// import { centers } from "../../../public/assets/public_data/CentersData";

const colors = {
  bg: {
    accordionColor: "var(--dark-transparent)",
    summaryColor: "#1d1d1dc3",
    detailsColor: "#ffffffc3",
  },
};
function InstCenters() {
  const context = useContext(Context);
  const [centers, setCenters] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const { t } = useTranslation();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const filteredCenters = centers
    ? Object.keys(centers).reduce((acc, key) => {
        acc[key] = centers[key].filter((center) => {
          const searchText = searchQuery.toLowerCase();
          return (
            center.name.toLowerCase().includes(searchText) ||
            center.city.toLowerCase().includes(searchText) ||
            center.carType.toLowerCase().includes(searchText) ||
            center.address1.toLowerCase().includes(searchText)
          );
        });
        return acc;
      }, {})
    : {};

  useEffect(() => {
    fetch("/assets/public_data/CentersData.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setCenters(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);

  console.log("centers: ", centers);
  if (loading) return <div>Loading...</div>;

  return (
    <Box
      className="centers-main-page"
      sx={{
        flexGrow: 1,
        width: "100%",
        minHeight: "100vh",
        backgroundImage: `url(${centersImg_en})`,
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
      dir={context.dir}
    >
      {/* centers welcome section */}
      {/* <Box
        className="centers-welcome-container"
        sx={{ display: { xs: "none", sm: "block", md: "block", lg: "block" } }}
      >
      </Box> */}

      {/* Search bar */}
      <Box sx={{ paddingTop: "100px" }}>
        <h1 className="oz-title" style={{ color: "var(--primary)" }}>
          {" "}
          {t("nav_centers")}
        </h1>
        <TextField
          label={t("centers_search_field")}
          variant="outlined"
          value={searchQuery}
          onChange={handleSearchChange}
          dir={context.dir}
          sx={{
            width: "90%",
            maxWidth: "600px", // Adjust the max width if necessary
            margin: "10px 0", // Optional, for spacing
            "& .MuiInputLabel-root": {
              fontSize: "14px", // Smaller font size for label
              fontWeight: "normal", // Normal font weight
              color: "var(--dark)", // Default label color
              transition: "color 0.3s ease", // Smooth transition for color change
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px", // Smooth rounded corners
              backgroundColor: "var(--light-transparent)",
              transition: "border-color 0.3s ease, box-shadow 0.3s ease", // Smooth border transition on focus
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ccc", // Lighter border color
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ff8c05", // Highlight on hover
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                borderColor: "#ff8c05", // Highlighted border when focused
              },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "var(--light)", // Change label color when focused
            },
            "& .MuiOutlinedInput-input": {
              // backgroundColor: "var(--light-transparent)", // Keep background color inside input field
            },
            "& .MuiOutlinedInput-root.Mui-focused": {
              boxShadow: "0 0 5px 2px rgba(255, 111, 0, 0.81)", // Red box shadow effect on focus
            },
          }}
        />
      </Box>

      <Box className="centers-main-container">
        {filteredCenters?.etit && (
          <div>
            <h1 className="oz-subtitle"> {t("centers_main")}</h1>
            <Grid container spacing={4}>
              {filteredCenters.etit.map((center) => (
                <Grid item xs={12} sm={12} md={12} lg={12} key={center.phone1}>
                  <Accordion
                    expanded={expanded === center.phone1}
                    onChange={handleChange(center.phone1)}
                    sx={{ backgroundColor: colors.bg.accordionColor }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: "#ff8c05" }} />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                      className="accordion-header"
                      sx={{ backgroundColor: colors.bg.summaryColor }}
                    >
                      <h2 sx={{ width: "100%", flexShrink: 0 }}>
                        {center.name} <p> {center.city}</p>{" "}
                      </h2>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{ backgroundColor: colors.bg.detailsColor }}
                    >
                      <Grid container>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <TextInputData
                            lable="نوع المركبه "
                            val={center.carType}
                          />
                          <TextInputData
                            lable=" 1 عنوان "
                            val={center.address1}
                          />
                          {center.address2 && (
                            <TextInputData
                              lable=" 2 عنوان "
                              val={center.address2}
                            />
                          )}
                          {center.director && (
                            <TextInputData
                              lable="المدير المسؤول "
                              val={center.director}
                            />
                          )}
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <TextInputData
                            lable="الخط الساخن / الهاتف  "
                            val={
                              center.phone2
                                ? center.phone1 + " - " + center.phone2
                                : center.phone1
                            }
                          />
                          {center.fax && (
                            <TextInputData lable="فاكس " val={center.fax} />
                          )}
                          {center.email && (
                            <TextInputData lable="إيميل " val={center.email} />
                          )}
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              ))}
            </Grid>
          </div>
        )}
        {filteredCenters?.cairo && (
          <div>
            <h1 className="oz-subtitle"> {t("centers_cairo")}</h1>
            <Grid container spacing={4}>
              {filteredCenters.cairo.map((center) => (
                <Grid item xs={12} sm={12} md={6} lg={6} key={center.phone1}>
                  <Accordion
                    expanded={expanded === center.phone1}
                    onChange={handleChange(center.phone1)}
                    sx={{ backgroundColor: colors.bg.accordionColor }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: "#ff8c05" }} />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                      className="accordion-header"
                      sx={{ backgroundColor: colors.bg.summaryColor }}
                    >
                      <h2 sx={{ width: "100%", flexShrink: 0 }}>
                        {center.name} <p> {center.city}</p>{" "}
                      </h2>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{ backgroundColor: colors.bg.detailsColor }}
                    >
                      <Grid container>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <TextInputData
                            lable="نوع المركبه "
                            val={center.carType}
                          />
                          <TextInputData
                            lable=" 1 عنوان "
                            val={center.address1}
                          />
                          {center.address2 && (
                            <TextInputData
                              lable=" 2 عنوان "
                              val={center.address2}
                            />
                          )}
                          {center.director && (
                            <TextInputData
                              lable="المدير المسؤول "
                              val={center.director}
                            />
                          )}
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <TextInputData
                            lable="الخط الساخن / الهاتف  "
                            val={
                              center.phone2
                                ? center.phone1 + " - " + center.phone2
                                : center.phone1
                            }
                          />
                          {center.fax && (
                            <TextInputData lable="فاكس " val={center.fax} />
                          )}
                          {center.email && (
                            <TextInputData lable="إيميل " val={center.email} />
                          )}
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              ))}
            </Grid>
          </div>
        )}
        {filteredCenters?.otherGovs && (
          <div>
            <h1 className="oz-subtitle"> {t("centers_other_govs")}</h1>
            <Grid container spacing={4}>
              {filteredCenters.otherGovs.map((center) => (
                <Grid item xs={12} sm={12} md={6} lg={6} key={center.phone1}>
                  <Accordion
                    expanded={expanded === center.phone1}
                    onChange={handleChange(center.phone1)}
                    sx={{ backgroundColor: colors.bg.accordionColor }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: "#ff8c05" }} />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                      className="accordion-header"
                      sx={{ backgroundColor: colors.bg.summaryColor }}
                    >
                      <h2 sx={{ width: "100%", flexShrink: 0 }}>
                        {center.name} <p> {center.city}</p>{" "}
                      </h2>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{ backgroundColor: colors.bg.detailsColor }}
                    >
                      <Grid container>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <TextInputData
                            lable="نوع المركبه "
                            val={center.carType}
                          />
                          <TextInputData
                            lable=" 1 عنوان "
                            val={center.address1}
                          />
                          {center.address2 && (
                            <TextInputData
                              lable=" 2 عنوان "
                              val={center.address2}
                            />
                          )}
                          {center.director && (
                            <TextInputData
                              lable="المدير المسؤول "
                              val={center.director}
                            />
                          )}
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <TextInputData
                            lable="الخط الساخن / الهاتف  "
                            val={
                              center.phone2
                                ? center.phone1 + " - " + center.phone2
                                : center.phone1
                            }
                          />
                          {center.fax && (
                            <TextInputData lable="فاكس " val={center.fax} />
                          )}
                          {center.email && (
                            <TextInputData lable="إيميل " val={center.email} />
                          )}
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              ))}
            </Grid>
          </div>
        )}
        {filteredCenters?.agents && (
          <div>
            <h1 className="oz-subtitle">{t("centers_agencies")}</h1>
            <Grid container spacing={4}>
              {filteredCenters.agents.map((center) => (
                <Grid item xs={12} sm={12} md={6} lg={6} key={center.phone1}>
                  <Accordion
                    expanded={expanded === center.phone1}
                    onChange={handleChange(center.phone1)}
                    sx={{ backgroundColor: colors.bg.accordionColor }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: "#ff8c05" }} />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                      className="accordion-header"
                      sx={{ backgroundColor: colors.bg.summaryColor }}
                    >
                      <h2 sx={{ width: "100%", flexShrink: 0 }}>
                        {center.name}
                      </h2>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{ backgroundColor: colors.bg.detailsColor }}
                    >
                      <Grid container>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <TextInputData
                            lable="نوع المركبه "
                            val={center.carType}
                          />
                          <TextInputData
                            lable=" 1 عنوان "
                            val={center.address1}
                          />
                          {center.address2 && (
                            <TextInputData
                              lable=" 2 عنوان "
                              val={center.address2}
                            />
                          )}
                          {center.address3 && (
                            <TextInputData
                              lable=" 3 عنوان "
                              val={center.address3}
                            />
                          )}
                          {center.address4 && (
                            <TextInputData
                              lable=" 4 عنوان "
                              val={center.address4}
                            />
                          )}
                          {center.address5 && (
                            <TextInputData
                              lable=" 5 عنوان "
                              val={center.address5}
                            />
                          )}
                          {center.director && (
                            <TextInputData
                              lable="المدير المسؤول "
                              val={center.director}
                            />
                          )}
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <TextInputData
                            lable="الخط الساخن / الهاتف  "
                            val={
                              center.phone2
                                ? center.phone1 + " - " + center.phone2
                                : center.phone1
                            }
                          />
                          {center.fax && (
                            <TextInputData lable="فاكس " val={center.fax} />
                          )}
                          {center.email && (
                            <TextInputData lable="إيميل " val={center.email} />
                          )}
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              ))}
            </Grid>
          </div>
        )}
      </Box>
    </Box>
  );
}

const TextInputData = (props) => {
  return (
    <TextField
      id="standard-read-only-input"
      label={props.lable}
      defaultValue={props.val}
      InputProps={{
        readOnly: true,
        // sx:{color:'#ff8c05'}
      }}
      variant="standard"
      style={{ marginBottom: "5px", width: "95%" }}
      multiline
      sx={{
        "& label": {
          width: "130%",
          display: "flex",
          justifyContent: "right",
          fontSize: "18px",
          fontWeight: "bold",
        },
      }}
    />
  );
};

export default InstCenters;
